var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsoxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 70",
    width: "150px",
    height: "32px",
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    "data-icon": "sync-alt",
    className: "svg-inline--fa fa-sync-alt fa-w-16",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    path {\n    fill: #8e8e8e;\n    }\n\n    @media (prefers-color-scheme: dark) {\n    path {\n    fill: #8e8e8e;\n    }\n    }\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "scale(0.5, 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lines"
  }, /*#__PURE__*/React.createElement("path", {
    id: "left",
    d: "M50.65,44.32v3c0,.85,0,1.69,0,2.54a.49.49,0,0,1-.29.51L33.54,60.06C32,60.94,30.49,61.81,29,62.7a.52.52,0,0,1-.62,0Q17.64,56.53,6.92,50.35a.48.48,0,0,1-.26-.49v-33a.48.48,0,0,1,.3-.51q8.55-4.93,17.09-9.88a.59.59,0,0,1,.69,0c.58.37,1.18.69,1.81,1.06L22,10.11q-6.45,3.72-12.91,7.44a.58.58,0,0,0-.34.57q0,15.22,0,30.44a.56.56,0,0,0,.34.57q9.58,5.53,19.15,11.07a.63.63,0,0,0,.73,0l19.08-11a.67.67,0,0,0,.4-.7c0-.86,0-1.73,0-2.59a.46.46,0,0,1,.28-.48C49.38,45.07,50,44.7,50.65,44.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "top",
    d: "M4.47,40.62C3,39.77,1.58,39,.15,38.14,0,38,0,37.86,0,37.71V30q0-8.51,0-17a.57.57,0,0,1,.33-.57L21.66.15a.55.55,0,0,1,.66,0l28,16.16a.6.6,0,0,1,.35.61q0,9.82,0,19.67a.55.55,0,0,1-.33.57c-.6.32-1.18.67-1.78,1a.93.93,0,0,1-.06-.51q0-9.73,0-19.47a.65.65,0,0,0-.38-.67q-12.9-7.44-25.78-14.9a.56.56,0,0,0-.63,0Q12.09,8.18,2.44,13.72a.48.48,0,0,0-.27.49v22.3a.44.44,0,0,0,.25.45l1.82,1a.4.4,0,0,1,.24.41C4.46,39.12,4.47,39.83,4.47,40.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "right",
    d: "M30.75,2.59c1.49-.86,3-1.69,4.4-2.54.21-.12.34,0,.48.08L50.78,8.87q3.12,1.82,6.25,3.6a.5.5,0,0,1,.29.51q0,12.38,0,24.73a.51.51,0,0,1-.3.51L29,54.38a.66.66,0,0,1-.77,0q-8.43-4.89-16.88-9.76a.55.55,0,0,1-.33-.56c0-.68,0-1.37,0-2.11l1.31.75,16,9.23a.57.57,0,0,0,.66,0Q41.83,44.5,54.7,37.08a.84.84,0,0,0,.49-.86c0-7.31,0-14.62,0-21.93a.57.57,0,0,0-.31-.58Q45.26,8.19,35.67,2.63a.57.57,0,0,0-.69,0c-.6.38-1.23.71-1.84,1.07a.38.38,0,0,1-.42,0C32.08,3.35,31.43,3,30.75,2.59Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44,15)",
    id: "svgGroup",
    strokeLinecap: "round",
    fillRule: "evenodd",
    fontSize: "9pt",
    stroke: "#8e8e8e",
    strokeWidth: "0.25mm",
    fill: "#8e8e8e",
    style: {
      stroke: "#8e8e8e",
      strokeWidth: "0.25mm",
      fill: "black"
    }
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 12,
    style: {
      font: "normal 32px sans-serif",
      fontFamily: "\"Helvetica Neue\", Helvetica, Arial, sans-serif",
      fontWeight: 400
    },
    fill: "#8e8e8e"
  }, "EnCo C-SOX")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsoxLogo);
export default __webpack_public_path__ + "static/media/csox-logo.94205bff87e2722f2e6b3b2ea0c49437.svg";
export { ForwardRef as ReactComponent };